import React from "react";
import { HomeIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

// Breadcrumbs Component
const Breadcrumbs = ({ activeSection, darkMode = false }) => {
  const getBreadcrumbLabel = (section) => {
    const labels = {
      dashboard: "Dashboard",
      "vaccines-list": "Vaccine Management > Vaccines",
      "stock-management": "Vaccine Management > Vaccine Inventory",
      "vaccination-plan": "Vaccine Management > Vaccination Plan",
      "vaccine-dispatch": "Vaccine Management > Vaccine Dispatch",
      "vaccine-transfer": "Vaccine Management > Vaccine Transfer",
      "vaccine-record": "Appointment > Vaccine Record",
      "vaccine-receive": "Vaccine Management > Vaccine Receive",
      "supplier-management": "Vaccine Management > Supplier Management",
      Appointment: "Appointment",
      "medical-staff": "Medical Staff",
      distric: "Location Management > District",
      taluka: "Location Management > Taluka",
      village: "Location Management > Village",
      patients: "Parents",
      children: "Children",
      "child-vaccination-plans": "Patient Management > Child Vaccination Plans",
      users: "Users",
      "activity-logs": "Users > Activity Logs",
      centers: "Location Management > Vaccination Center",
      roles: "Roles & Permissions > Roles",
      modules: "Roles & Permissions > Modules",
      settings: "General Settings",
    };
    return labels[section] || "Dashboard";
  };

  const breadcrumbText = getBreadcrumbLabel(activeSection);
  const parts = ["Home", ...breadcrumbText.split(" > ")];

  return (
    <nav className="flex items-center space-x-1 text-sm" aria-label="Breadcrumb">
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {index === 0 ? (
            <div
              className={`
              flex items-center gap-1.5 px-2 py-1 rounded-lg transition-colors
              ${darkMode ? "text-gray-400 hover:text-gray-200 hover:bg-gray-800" : "text-gray-500 hover:text-gray-700 hover:bg-gray-100"}
            `}
            >
              <HomeIcon className="w-4 h-4" />
              <span className="hidden sm:inline">{part}</span>
            </div>
          ) : (
            <>
              <ChevronRightIcon className={`w-4 h-4 flex-shrink-0 ${darkMode ? "text-gray-600" : "text-gray-400"}`} />
              <span
                className={`
                  px-2 py-1 rounded-lg transition-colors
                  ${index === parts.length - 1 ? (darkMode ? "text-white font-medium bg-gray-800" : "text-gray-900 font-medium bg-gray-100") : darkMode ? "text-gray-400" : "text-gray-500"}
                `}
              >
                {part}
              </span>
            </>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
